var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-pdf-app',{ref:"pdfViewer",style:({ height: '100%', width: '100%' }),attrs:{"pdf":_vm.url,"loading":_vm.loading,"config":{ toolbar: 'viewFind' }},on:{"pages-rendered":_vm.onPagesRendered}})
}
var staticRenderFns = []

export { render, staticRenderFns }